// extracted by mini-css-extract-plugin
export default {"title":"Title_title__Let3M","subtitle":"Title_subtitle__2hR5b"};